export const AppConstants = {
    formulaComponentId: 3,
    dataCleansingComponentId: 4,
    platformAdminT1GroupId: 'ba2233f5-d1c8-4d50-842e-a020b409f78f',
};
